export default __webpack_public_path__ + "static/media/badges.6afa5794.png";